/**
 * @fileoverview Engagement tracking endpoints reused between widgets.
 */
export const ENGAGEMENT_CREATE_CTA_IMPRESSION = {
    url: '/trk/engagement:create_cta_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const ENGAGEMENT_CLICK_CTA = {
    url: '/trk/engagement:click_cta',
    isUserEngagement: true,
    consent: 'essential',
};
// https://github.com/loopsocial/schema_repo/blob/master/tracker/engagement%3Ainteractable_engaged_view.md
export const ENGAGEMENT_INTERACTABLE_VIEW = {
    url: '/trk/engagement:interactable_engaged_view',
    isUserEngagement: true,
    consent: 'essential',
};
export const ENGAGEMENT_INTERACTABLE_VIEW_V2 = {
    url: '/trk/engagement:interactable_engaged_view_v2',
    isUserEngagement: true,
    consent: 'essential',
};
export const ENGAGEMENT_CLICK_CC = {
    url: '/trk/engagement:click_closed_captioning',
    consent: 'essential',
    isUserEngagement: true,
};
